export default __webpack_public_path__ + "static/media/PPFPageLocation.744ae91c.jpg";